module.exports = __webpack_public_path__ + "static/BrandWideReporting-2780eae619558ef62a17d6c94554d677.jpg";